"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubCategoryTitle = exports.SubCategorySegment = exports.SubCategoryRoot = exports.SubCategoryListElement = exports.SubCategoryIconWrapper = exports.MobileSubLinksRoot = exports.MobileSkeletonRoot = exports.MobileItemSkeleton = exports.DesktopSubLinksSubcategory = exports.DesktopSubLinksSegment = exports.DesktopSubLinksRoot = exports.DesktopSubLinksOtherLinks = exports.DesktopSubLinksNewAndAllRoot = exports.DesktopSubLinksNewAndAll = exports.DesktopSkeletonRoot = exports.DesktopSkeletonInner = exports.DesktopItemSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const DesktopSubLinksRoot = exports.DesktopSubLinksRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  marginTop: theme.spacing(3),
  '& *': {
    boxSizing: 'border-box'
  },
  display: 'flex',
  flexFlow: 'row wrap',
  margin: 0,
  padding: theme.spacing(2, 12, 4, 12),
  maxWidth: '60vw'
}));
const DesktopSubLinksOtherLinks = exports.DesktopSubLinksOtherLinks = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1)
  }
}));
const DesktopSubLinksSubcategory = exports.DesktopSubLinksSubcategory = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    padding: theme.spacing(0, 10, 6, 0),
    alignItems: 'start',
    order: 0,
    gap: theme.spacing(6, 12)
  }
}));
const DesktopSubLinksNewAndAllRoot = exports.DesktopSubLinksNewAndAllRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(6, 12, 0, 12)
}));
const DesktopSubLinksNewAndAll = exports.DesktopSubLinksNewAndAll = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    fontSize: '2rem',
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '2.3rem',
    textDecoration: 'none',
    paddingLeft: theme.spacing(1),
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      WebkitTapHighlightColor: 'transparent'
    },
    svg: {
      marginLeft: theme.spacing(2),
      verticalAlign: 'text-top'
    }
  }
}));
const DesktopSubLinksSegment = exports.DesktopSubLinksSegment = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'block',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightLight,
    lineHeight: '2.1rem',
    order: 2,
    padding: 0,
    textDecoration: 'none',
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      WebkitTapHighlightColor: 'transparent'
    }
  }
}));
const SubCategoryRoot = exports.SubCategoryRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  listStyle: 'none',
  '&:first-of-type': {
    paddingTop: 0
  },
  '&:last-child': {
    paddingBottom: theme.spacing(2)
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0, 6, 6, 1),
    '&:last-child': {
      paddingBottom: 'unset'
    }
  }
}));
const SubCategoryListElement = exports.SubCategoryListElement = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3, 2, 10),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 0, 2, 0),
    fontSize: '1.6rem'
  }
}));
const SubCategoryTitle = exports.SubCategoryTitle = (0, _mui.styled)(_mui.Link, {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  boldText
}) => ({
  color: theme.palette.text.primary,
  display: 'inline-block',
  fontSize: '1.7rem',
  fontWeight: boldText ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular,
  maxWidth: 235,
  height: 30,
  overflow: 'hidden',
  paddingLeft: 0,
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  [theme.breakpoints.up('md')]: {
    display: 'unset',
    lineHeight: '1.6rem',
    fontSize: '1.6rem',
    maxWidth: 250,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      WebkitTapHighlightColor: 'transparent'
    }
  }
}));
const SubCategoryIconWrapper = exports.SubCategoryIconWrapper = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isSubCategoryActive,
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: theme.typography.h6.fontSize,
  marginRight: 3,
  // With love for Eliška <3

  transition: '0.1s ease-in',
  ...(isSubCategoryActive && {
    transform: 'rotate(180deg)'
  })
}));
const SubCategorySegment = exports.SubCategorySegment = (0, _mui.styled)(_mui.Link, {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  children,
  isBestOffers
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  fontSize: '1.6rem',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  fontWeight: theme.typography.fontWeightLight,
  lineHeight: '2.1rem',
  maxWidth: isBestOffers ? 'none' : 235,
  overflow: 'hidden',
  padding: theme.spacing(2, 3, 2, 14),
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  maxHeight: 73,
  '&:hover, &:focus': {
    color: theme.palette.grey[600]
  },
  '&:active': {
    fontWeight: theme.typography.fontWeightBold
  },
  [theme.breakpoints.up('md')]: {
    padding: 0,
    '&:first-of-type': {
      marginTop: 'unset',
      paddingTop: 'unset'
    },
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      WebkitTapHighlightColor: 'transparent'
    },
    '&:active': {
      fontWeight: 'unset'
    },
    '&::before': {
      display: 'block',
      height: 0,
      content: `"${typeof children === 'string' || typeof children === 'number' ? children : ''}"`,
      fontWeight: 'bold',
      visibility: 'hidden'
    }
  }
}));
const MobileSubLinksRoot = exports.MobileSubLinksRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  marginTop: theme.spacing(3),
  width: '100%',
  '& *': {
    boxSizing: 'border-box'
  }
}));
const MobileSkeletonRoot = exports.MobileSkeletonRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(3),
  padding: theme.spacing(0, 10)
}));
const MobileItemSkeleton = exports.MobileItemSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(2, 0),
  transform: 'initial'
}));
const DesktopSkeletonRoot = exports.DesktopSkeletonRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  padding: theme.spacing(6, 12, 0, 12)
}));
const DesktopSkeletonInner = exports.DesktopSkeletonInner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexFlow: 'column wrap',
  gap: theme.spacing(9, 6),
  maxHeight: 700,
  [theme.breakpoints.up('lg')]: {
    maxHeight: 500
  }
}));
const DesktopItemSkeleton = exports.DesktopItemSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'initial'
});
